import React, { useCallback } from 'react';

import { TextField, InputAdornment, MenuItem } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

export default function InputMaterialUI({
  type,
  onSubmit,
  initials,
  id,
  options,
  onGetValueTemp,
  keySubmit
}) {
  const [data, setData] = React.useState(null);
  const [auto, setAuto] = React.useState(false);
  const [edited, setEdited] = React.useState(false);

  // Changed input
  const handleSubmit = React.useCallback((value) => {
    setData(value);
    setEdited(true);
    onSubmit(id, type, value)

    // Check type select
    if (type === 'select') setAuto(true);
  }, []);

  const handleKey = useCallback((value) => {
    if (value == 'Enter') {
      keySubmit('Enter')
    }

  }, [])

  // Submit input to press "Enter"
  const handleKeyPress = React.useCallback(
    (value) => {
      if (value === 'Enter' && edited) onSubmit(id, type, data);
    },
    [data, edited]
  );

  // Icon
  const startAdornment = React.useMemo(() => {
    if (isEmpty(options))
      return (
        <InputAdornment position="start">
          <Search />
        </InputAdornment>
      );
  }, []);

  // Type component
  const modifyType = React.useMemo(() => {
    if (!isEmpty(options)) return undefined;

    switch (type) {
      case 'initialtime':
      case 'finaltime':
        return 'time';
      case 'text':
      case 'number':
      case 'date':
      case 'time':
        return type;
      default:
        return 'text';
    }
  }, [options, type]);

  // Render options to component Select
  const handleRenderOptions = React.useMemo(
    () =>
      options.map((option) => (
        <MenuItem key={option.label} value={option.label}>
          {option.value}
        </MenuItem>
      )),
    [options]
  );

  // Submit value in field type select
  React.useEffect(() => {
    if (auto) handleKey('Enter');
  }, [data]);

  React.useEffect(() => {
    setData(initials);
  }, [initials]);

  return (
    <TextField
      fullWidth
      size="small"
      type={modifyType}
      select={!isEmpty(options)}
      style={{ marginTop: '0px' }}
      onChange={({ target }) => handleSubmit(target.value)}
      InputProps={{ startAdornment }}
      value={data}
      onKeyUp={({ key }) => handleKey(key)}
      onBlur={({ target }) => onGetValueTemp(id, type, target.value)}
    >
      {!isEmpty(options) && <MenuItem value=" ">Todos</MenuItem>}
      {!isEmpty(options) && handleRenderOptions}
    </TextField>
  );
}

InputMaterialUI.propTypes = {
  type: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  initials: PropTypes.string,
  id: PropTypes.oneOfType(PropTypes.string, PropTypes.number).isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
  onGetValueTemp: PropTypes.func.isRequired,
};

InputMaterialUI.defaultProps = {
  type: 'text',
  initials: '',
  options: [],
};
